import React, { useEffect } from 'react'
import Section from "./Section";
import BlogContent from './BlogContent';
import MetaTags from '../../helpers/Common/MetaTags';
import { getMetaConfig } from '../../helpers/Common/metaConfig';
import { generateBlogListingsSchema } from '../../helpers/Common/blogSchema';

const Blogs = () => {

    useEffect(() => {
        window.scrollTo({
            top:150,
            behavior: "smooth",
          });
    }, [])
    
    // Prepare Blog schema data for listings page
    const blogListingsData = generateBlogListingsSchema();
    
    const blogsMeta = getMetaConfig('blogs', {
      blogPosting: blogListingsData
    });
    
    return (
        <React.Fragment>
            <MetaTags {...blogsMeta} />
            <Section/>
            <BlogContent/>
        </React.Fragment>
    )
}

export default Blogs;
